var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.696 11.057c-1.632 0-3.314.395-3.76 1.137v.05V7h-4.402v8.262c.445.197.89.445 1.335.692.148.1.296.149.395.198.05.05.1.05.198.099 0 0-2.523 3.91-5.936 4.7-2.029.495-4.403-.098-4.898-2.127 0-.099-.05-.148-.05-.247.346-.198.643-.346.989-.544.84-.347 1.483-.643 1.73-.742h.05c2.028-.742 3.71-.99 3.71-.99-1.534-.148-2.82-.05-3.958.198-.989.198-1.83.495-2.424.792.347-1.435 1.633-2.721 3.166-3.067.149-.05.248-.05.396-.1h.1c.098 0 .197-.049.296-.049H13.775c.643.05 1.434.248 2.325.544v-2.77c-.446-.148-.892-.247-1.337-.396-1.286-.296-3.413-.643-5.738-.099-3.76.89-4.799 3.661-4.799 7.025 0 .445.05.841.1 1.187-.792.545-1.633 1.138-2.326 1.83 0 0 1.088-.494 2.523-1.088.94 3.216 4.304 4.304 6.777 4.304 2.622.001 4.304-.74 6.283-1.978v1.583h4.403V16.3c.396-1.088 1.138-1.385 1.93-1.385 1.038 0 1.681.742 1.681 1.93v7.42H30v-8.707c0-2.72-1.731-4.501-4.304-4.501z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXch);
export default __webpack_public_path__ + "static/media/XCH.cf5e3f373fd21d67c43b846a620075ac.svg";
export { ForwardRef as ReactComponent };